// extracted by mini-css-extract-plugin
module.exports = {"toggleTax":"ToggleTax_toggleTax__Eerh8","toggleTaxInput":"ToggleTax_toggleTaxInput__nzZP8","toggleTaxLabel":"ToggleTax_toggleTaxLabel__ZChuY"};